import { Typography, Box, Grid, Divider, Button } from "@mui/material";
import FormikButton from "@/components/forms/FormikButton";
import React, { useState } from "react";
import { StyledButton } from "@/components";
import DialogForm from "@/components/modal/DialogForm";
import { set } from "lodash";
import DocViewModal from "@/components/documentViewModal/DocViewModal";
const ViewHoliday = ({
  event,
  open,
  handleCloseDialog,
  setOpen,
  handleDelete,
  handleEdit,
  onDeleteClick,
  responseData,
  setHideBtn,
}) => {
  if (!event) return null;
  console.log(event);
  const [preview, setOpenPreview] = useState(false);
  const [fileName, setFileName] = useState("");

  const handleImage = (value) => {
    console.log(value);
    setOpenPreview(true);
    setFileName(value);
  };

  const formattedStart = event?.date
    ? (() => {
        const date = new Date(event.date);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      })()
    : "-";
  console.log(event?.locations);

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={4}>
            <Typography variant="body1" fontWeight="bold">
              Occasion:
            </Typography>
          </Grid>
          <Grid item xs={8} sx={{ textTransform: "capitalize" }}>
            <Typography variant="body1">{event?.occasion || "-"}</Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2} alignItems="center">
          <Grid item xs={4}>
            <Typography variant="body1" fontWeight="bold">
              Date:
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="body1">{formattedStart}</Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2} alignItems="center">
          <Grid item xs={4}>
            <Typography variant="body1" fontWeight="bold">
              Description:
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="body1" sx={{ textTransform: "capitalize" }}>
              {event?.discription || "-"}
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2} alignItems="center">
          <Grid item xs={4}>
            <Typography variant="body1" fontWeight="bold">
              Restricted Holiday:
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="body1" sx={{ textTransform: "capitalize" }}>
              {event?.restrictedHoliday || "-"}
            </Typography>
          </Grid>
        </Grid>
        {/* {event?.stateList.length > 0 && (
          <Grid
            container
            spacing={2}
            alignItems="center"
            sx={{ marginTop: "10px", marginBottom: "20px" }}
          >
            <Grid item xs={4}>
              <Typography variant="body1" fontWeight="bold">
                State List:
              </Typography>
            </Grid>
            <Grid
              item
              xs={8}
              sx={{
                maxHeight: "85px",
                overflowY: "auto",
                margin: "auto",
              }}
            >
              <Typography variant="body1" sx={{ textTransform: "capitalize" }}>
                {event?.stateList.map((item) => item.name || item).join(", ") ||
                  event?.stateList.join(", ")}
              </Typography>
            </Grid>
          </Grid>
        )} */}

        {event?.locations.length > 0 && (
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={4}>
              <Typography variant="body1" fontWeight="bold">
                Locations:
              </Typography>
            </Grid>
            <Grid
              item
              xs={8}
              sx={{
                maxHeight: "85px",
                overflowY: "auto",
                margin: "auto",
              }}
            >
              <Typography variant="body1" sx={{ textTransform: "capitalize" }}>
                {event?.locations.map((item) => item.name || item).join(", ") ||
                  event?.locations.join(", ")}
              </Typography>
            </Grid>
          </Grid>
        )}
        {event?.file && (
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={4}>
              <Typography variant="body1" fontWeight="bold">
                Attachment:
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Button
                disabled={preview}
                variant="contained"
                onClick={() => {
                  handleImage(event?.file);
                }}
              >
                {preview ? "Opening..." : "Attachment"}
              </Button>
            </Grid>
          </Grid>
        )}

        <Divider sx={{ mt: 1, mb: 2 }} />
        <Grid
          container
          spacing={2}
          justifyContent={"flex-end"}
          alignItems="center"
        >
          {!setHideBtn && (
            <>
              <StyledButton
                type="button"
                sx={{ ml: 1 }}
                variant="contained"
                label="Edit"
                onClick={handleEdit}
              />
              <StyledButton
                type="button"
                sx={{ ml: 1 }}
                variant="contained"
                label="Delete"
                onClick={onDeleteClick}
              />
            </>
          )}

          <StyledButton
            type="button"
            sx={{ ml: 1 }}
            variant="contained"
            label="Close"
            onClick={handleCloseDialog}
          />
        </Grid>
        <DocViewModal
          open={preview}
          setOpen={setOpenPreview}
          file={fileName ? [fileName] : []}
          folder={"HOLIDAY"}
        />
      </Box>
    </>
  );
};

export default ViewHoliday;
